"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TrackContext = (0, react_1.createContext)({ track: () => null });
const TrackProvider = ({ track, children }) => ((0, jsx_runtime_1.jsx)(TrackContext.Provider, { value: { track }, children: children }));
const useTrack = () => (0, react_1.useContext)(TrackContext);
exports.useTrack = useTrack;
exports.default = TrackProvider;
